import { THEMES, type AppTheme } from './catalog';
import { Fragment, type ReactNode } from 'react';

/** One theme option component across products; the host controls its translated label. */
export function ThemePicker({ value, onChange, label = 'Theme', optionLabel = theme => theme, renderOption }: {
  value: AppTheme;
  onChange: (theme: AppTheme) => void;
  label?: string;
  optionLabel?: (theme: AppTheme) => string;
  renderOption?: (theme: AppTheme) => ReactNode;
}) {
  if (renderOption) return <>{THEMES.map(theme => <Fragment key={theme}>{renderOption(theme)}</Fragment>)}</>;
  return <select aria-label={label} value={value} onChange={event => onChange(event.target.value as AppTheme)}>
    {THEMES.map(theme => <option key={theme} value={theme}>{optionLabel(theme)}</option>)}
  </select>;
}
